import script from "./DirectComponentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectComponentTable.vue?vue&type=script&setup=true&lang=js"

import "./DirectComponentTable.vue?vue&type=style&index=0&id=4e4780f2&lang=css"

const __exports__ = script;

export default __exports__